export const hasInspectorFinalDecision = (property, inspectorId = null) => {
  if (!property) return false;

  const reassessVal = property.reassess;
  const hasReassessDecision =
    reassessVal === 0 ||
    reassessVal === 1 ||
    reassessVal === "0" ||
    reassessVal === "1" ||
    reassessVal === true ||
    reassessVal === false;

  if (hasReassessDecision) return true;

  if (inspectorId != null && property.updated_by != null) {
    const updatedBy = String(property.updated_by).trim();
    if (
      updatedBy &&
      updatedBy.toLowerCase() !== "null" &&
      updatedBy.toLowerCase() !== "undefined" &&
      String(inspectorId) === updatedBy
    ) {
      return true;
    }
  }

  return false;
};

export const isSupervisorDecisionLocked = (property) => {
  if (!property) return false;
  const status = String(property.status || "").toLowerCase();
  return status === "resolved" || status === "assigned";
};
